export default __webpack_public_path__ + "static/char-v-01-d02d91865168649ed61ec71516f8112e.png";